// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__24Pap","select":"Header_select__3DK2y","clinic":"Header_clinic__3yPOC"};